import { Web3AuthError } from './authorizeWrite';
import { createJsonRpcDidReader } from './ethersDidReader';
import { verifyGlobalDidAccess } from './didEligibility';

export interface ApplicationIdentity {
  walletAddress: string;
  didId: number;
}

/**
 * Applicant identity is the connected wallet + a live Global DID check.
 * No SIWE session is required — the registry submit tx is the proof of control.
 * Recording happens when they apply, not when they connect.
 */
export async function requireApplicationIdentity(
  connectedAddress?: string | null
): Promise<ApplicationIdentity> {
  if (!connectedAddress) {
    throw new Web3AuthError(
      'Connect your wallet on Apertum to apply.',
      'not_signed_in'
    );
  }
  const { reader } = createJsonRpcDidReader();
  const eligibility = await verifyGlobalDidAccess({
    wallet: connectedAddress,
    reader,
  });
  if (!eligibility.eligible || eligibility.didId == null) {
    throw new Web3AuthError(
      eligibility.message || 'A valid Global DID is required to apply.',
      'did_ineligible'
    );
  }
  return { walletAddress: connectedAddress, didId: eligibility.didId };
}

export function identityStoragePath(didId: number, fileName: string): string {
  const safe = fileName.replace(/[^a-zA-Z0-9._-]/g, '_');
  return `${didId}/${Date.now()}-${safe}`;
}
